import React, { useState } from "react"
import { Collapse, Container } from "reactstrap"

export const CollapsibleContainer = ({ children, className = null }) => {
	const [isCollapsed, setIsCollapse] = useState(false)
	return (
		<Container fluid className={`border bg-white rounded${className ? " " + className : ""}`}>
			<div
				className="d-flex align-items-center pe-4 py-4 ms-4"
				onClick={() => setIsCollapse(!isCollapsed)}
			>
				<div className="flex-grow-1">
					{children[0]}
				</div>
				<span className="text-end">
					<img
						className="cursor_pointer btn"
						onClick={() => setIsCollapse(!isCollapsed)}
						src={isCollapsed ? "https://static.sibilus.eu/gfx/arrow-down-icon-0.svg" : "https://static.sibilus.eu/gfx/arrow-up-icon-0.svg"}
						alt="down-arrow"
					/>
				</span>
			</div>
			<Collapse isOpen={!isCollapsed}>
				{children[1]}
			</Collapse>
		</Container>
	)
}
